import { render, staticRenderFns } from "./AddPatientsToProgram.vue?vue&type=template&id=2e7e7ce1&scoped=true"
import script from "./AddPatientsToProgram.vue?vue&type=script&lang=js"
export * from "./AddPatientsToProgram.vue?vue&type=script&lang=js"
import style0 from "./AddPatientsToProgram.vue?vue&type=style&index=0&id=2e7e7ce1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7e7ce1",
  null
  
)

export default component.exports